module.exports = __webpack_public_path__ + "media/svgs/PDF-Download_Icon-e0fd4427b91f84f681a0b79b5b56c475.svg";